<div class="card">
    <app-header titulo="Cadastro de depósito" descricao="Digite as informações do depósito"></app-header>

    <div class="formgrid grid p-fluid">
        <div class="field col-4">
            <label for="instancia">Instância: </label>
            <input
              type="text"
              id="instancia"
              pInputText
              [(ngModel)]="deposito.instancia"
              required
            />
          </div>
          <div class="field col-4">
            <label for="empresaerp">Empresa ERP: </label>
            <input
              type="text"
              id="empresaerp"
              pInputText
              [(ngModel)]="deposito.cdEmpresaErp"
              required
            />
          </div>
          <div class="field col-4">
            <label for="filiaerp">Centro ERP: </label>
            <input
              type="text"
              id="filiaerp"
              pInputText
              [(ngModel)]="deposito.cdFilialErp"
              required
            />
          </div>
          <div class="field col-4">
            <label for="deposito">Depósito ERP: </label>
            <input
              type="text"
              id="deposito"
              pInputText
              [(ngModel)]="deposito.cdDepositoErp"
              required
            />
          </div>
          <div class="field col-4">
            <label for="tipoErp">Tipo Depósito: </label>
            <input
              type="text"
              id="tipoErp"
              pInputText
              [(ngModel)]="deposito.cdTipoDep"
              required
            />
          </div>
          <div class="field col-4">
            <label for="padrao">Padrão: </label>
            <input
              type="text"
              id="padrao"
              pInputText
              [(ngModel)]="deposito.fgPadrao"
              required
            />
          </div>
    </div>

    <p-fieldset legend="Posições">
        <button
        pButton
        icon="pi pi-plus"
        label="Nova Posição"
        (click)="abreNovoDialog()"
      ></button>

        <div class="mt-1">
            <p-table [value]="deposito.posicoes" editMode="row">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Código Posição</th>
                        <th>Descrição</th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-posicao let-editing="editing" let-ri="rowindex">
                    <tr pEditableRow="ambiente">
                        <td>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                        <input
                                          pInputText
                                          type="text"
                                          [(ngModel)]="posicao.cdPosicao"
                                          required
                                        />
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{ posicao.cdPosicao }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input
                                    pInputText
                                    type="text"
                                    [(ngModel)]="posicao.dePosicao"
                                    required
                                  />
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{ posicao.dePosicao }}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td>
                            <p-button
                      *ngIf="!editing"
                      icon="pi pi-pencil"
                      [rounded]="true"
                      pInitEditableRow
                      [text]="true"
                      severity="info"
                      (click)="editarPosicao(posicao)"
                      aria-label="Editar"
                    ></p-button>
    
                    <p-button
                      *ngIf="editing"
                      icon="pi pi-check"
                      [rounded]="true"
                      pSaveEditableRow
                      [text]="true"
                      severity="info"
                      (click)="atualizarPosicao(posicao, ri)"
                      aria-label="Salvar"
                    ></p-button>
                    <p-button
                      *ngIf="editing"
                      icon="pi pi-times"
                      [rounded]="true"
                      pCancelEditableRow
                      [text]="true"
                      severity="danger"
                      (click)="cancelarPosicao(posicao, ri)"
                      aria-label="Cancelar"
                    ></p-button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <app-posicao-dialog
    [visivel]="abreNovoPosicao"
    (fechar)="escondeNovoDialog()"
    [deposito]="deposito.id"
  ></app-posicao-dialog>
    </p-fieldset>
</div>